import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';

const LmsStatItem = ({ title, description, className }) => {
  return (
    <Col xxl={3} md={6} className={`${className} px-0 py-xxl-0 px-md-3`}>
      <p className="fs--1 fw-semi-bold mb-0">
        <span className="text-800 fw-normal">{description}</span>
      </p>
      <h4 className="mb-1 font-sans-serif">
        <span className="fw-normal text-green-600">{title}</span>
      </h4>
    </Col>
  );
};

LmsStatItem.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string
};

export default LmsStatItem;
